import { render } from "./OrganicCvrCard.vue?vue&type=template&id=25a31a34"
import script from "./OrganicCvrCard.vue?vue&type=script&lang=js"
export * from "./OrganicCvrCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__